import { MapPin } from 'lucide-react';
import { cssColor } from '@/theme/colors';

/** Il pannello illustrato accanto al login: mappa stilizzata e messaggio del marchio, senza movimento. */
export default function LoginMapPanel() {
  return (
    <div className="relative flex min-h-[280px] flex-1 overflow-hidden lg:min-h-screen">
      <div
        className="absolute inset-0 bg-linear-to-b from-accent-marine-deep via-accent-marine to-accent-marine-soft"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute left-[-20%] top-[10%] h-[min(420px,55vw)] w-[min(420px,55vw)] rounded-full bg-accent-blue/25 blur-3xl"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute right-[-15%] bottom-[20%] h-[min(380px,50vw)] w-[min(380px,50vw)] rounded-full bg-accent-cyan/5 blur-3xl"
        aria-hidden
      />

      <svg
        className="absolute inset-0 h-full w-full opacity-[0.35]"
        viewBox="0 0 400 800"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid slice"
        aria-hidden
      >
        <defs>
          <pattern id="login-map-grid" width="48" height="48" patternUnits="userSpaceOnUse">
            <path
              d="M0 24h48M24 0v48"
              fill="none"
              style={{ stroke: cssColor('accent.sky.pale', 0.12) }}
              strokeWidth="0.5"
            />
          </pattern>
          <linearGradient id="login-street-glow" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: cssColor('accent.sky.pale', 0.25) }} />
            <stop offset="100%" style={{ stopColor: cssColor('accent.amber.soft', 0.15) }} />
          </linearGradient>
        </defs>
        <rect width="400" height="800" fill="url(#login-map-grid)" />
        <path
          d="M -20 160 Q 120 120 200 280 T 420 200"
          fill="none"
          stroke="url(#login-street-glow)"
          strokeWidth="4"
          opacity="0.5"
        />
        <path
          d="M 0 440 L 400 360"
          fill="none"
          style={{ stroke: cssColor('accent.amber', 0.35) }}
          strokeWidth="6"
          strokeLinecap="round"
        />
        <path
          d="M 40 800 Q 160 560 280 640 T 400 480"
          fill="none"
          style={{ stroke: cssColor('accent.sky.pale', 0.25) }}
          strokeWidth="3"
        />
        <path
          d="M 60 0 L 100 800 M 240 0 L 220 800 M 0 320 L 400 400"
          fill="none"
          style={{ stroke: cssColor('accent.sky.pale', 0.18) }}
          strokeWidth="2"
        />
      </svg>
      <div
        className="absolute inset-0 bg-linear-to-t from-accent-marine-deep/90 via-transparent to-accent-marine-deep/40"
        aria-hidden
      />

      <div className="relative z-10 flex flex-1 flex-col justify-end p-10 lg:p-14 xl:p-16">
        <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-full border-2 border-dashed border-accent-white/40 bg-accent-white/5">
          <MapPin className="h-5 w-5 text-on-emphasis" aria-hidden />
        </div>
        <p className="mb-6 max-w-xl text-body-lg text-on-emphasis/90">
          Flotta, manutenzione e operazioni in un unico hub.
        </p>
        <blockquote className="max-w-xl text-hero-title text-on-emphasis lg:text-page-title">
          «Precisione in ogni chilometro. Efficienza in ogni consegna.»
        </blockquote>
        <p className="mt-5 text-sm text-on-emphasis/85">Movo Fleet · Sala operativa</p>
      </div>
    </div>
  );
}
